/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_Learnmore1Inputs */

const en_welcome_accreditation_learnmore1 = /** @type {(inputs: Welcome_Accreditation_Learnmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more about Accredited Investor requirements`)
};

/**
* | output |
* | --- |
* | "Learn more about Accredited Investor requirements" |
*
* @param {Welcome_Accreditation_Learnmore1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_accreditation_learnmore1 = /** @type {((inputs?: Welcome_Accreditation_Learnmore1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_Learnmore1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_learnmore1(inputs)
});
export { welcome_accreditation_learnmore1 as "welcome_accreditation_learnMore" }